<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100">{{ "rules_management.add_rule" | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <form class="col-12" [formGroup]="addRuleForm">
            <div class="bg-card shadow-md rounded p-2 mb-3">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.nameAE' | translate"
                            formControlName="nameAE"
                            controlName="nameAE"
                            [invalid]="checkInvalid('nameAE')"
                            [required]="true"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.nameEN' | translate"
                            formControlName="nameEN"
                            controlName="nameEN"
                            [invalid]="checkInvalid('nameEN')"
                            [required]="true"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.descriptionAE' | translate"
                            formControlName="dscAE"
                            controlName="dscAE"
                            [invalid]="checkInvalid('dscAE')"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.descriptionEN' | translate"
                            formControlName="dscEN"
                            controlName="dscEN"
                            [invalid]="checkInvalid('dscEN')"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.errorMessageAE' | translate"
                            formControlName="errorMessageAE"
                            controlName="errorMessageAE"
                            [invalid]="checkInvalid('errorMessageAE')"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [setValidator]="formValidation()!"
                            [label]="'common.form.label.errorMessageEN' | translate"
                            formControlName="errorMessageEN"
                            controlName="errorMessageEN"
                            [invalid]="checkInvalid('errorMessageEN')"
                            [isTextArea]="true"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <adaa-form-dropdown
                        [setValidator]="formValidation()!"
                        formControlName="ruleType"
                        controlName="ruleType"
                        [options]="ruleTypes()"
                        [label]="'rules_management.ruleType' | translate"
                        [invalid]="checkInvalid('ruleType')"
                        [clearable]="true"
                        (inputChanges)="onRuleTypeChange($event)"
                        appendTo=".modal-content"
                    ></adaa-form-dropdown>
                </div>
                @if (
                    selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_MANDATORY_CHECK ||
                    selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_VALUE_CHECK
                ) {
                    <div class="row">
                        <div
                            [class.col-4]="selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_MANDATORY_CHECK"
                            [class.col-3]="selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_VALUE_CHECK"
                        >
                            <adaa-form-dropdown
                                [setValidator]="formValidation()!"
                                formControlName="objectType"
                                controlName="objectType"
                                [options]="tables()"
                                [label]="'rules_management.table' | translate"
                                [invalid]="checkInvalid('objectType')"
                                [clearable]="true"
                                (inputChanges)="getFields($event)"
                                appendTo=".modal-content"
                            ></adaa-form-dropdown>
                        </div>
                        <div
                            [class.col-4]="selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_MANDATORY_CHECK"
                            [class.col-3]="selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_VALUE_CHECK"
                        >
                            <adaa-form-dropdown
                                [setValidator]="formValidation()!"
                                formControlName="objectField"
                                controlName="objectField"
                                [options]="fields()"
                                [label]="'rules_management.field' | translate"
                                [invalid]="checkInvalid('objectField')"
                                [clearable]="true"
                                appendTo=".modal-content"
                            ></adaa-form-dropdown>
                        </div>
                        @if (selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_MANDATORY_CHECK) {
                            <p class="fw-bold col-4 text-center mt-4">{{ "rules_management.is_not_null" | translate }}</p>
                        }
                        @if (selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_VALUE_CHECK) {
                            <div class="col-3">
                                <adaa-form-dropdown
                                    [setValidator]="formValidation()!"
                                    formControlName="operatorId"
                                    controlName="operatorId"
                                    [options]="operators()"
                                    [label]="'rules_management.operator' | translate"
                                    [invalid]="checkInvalid('operatorId')"
                                    [clearable]="true"
                                    appendTo=".modal-content"
                                    [required]="true"
                                ></adaa-form-dropdown>
                            </div>
                            <div class="col-3">
                                <adaa-form-input
                                    [setValidator]="formValidation()!"
                                    [label]="'rules_management.value' | translate"
                                    formControlName="objectValue"
                                    controlName="objectValue"
                                    [invalid]="checkInvalid('objectValue')"
                                    [required]="true"
                                ></adaa-form-input>
                            </div>
                        }
                    </div>
                }
                @if (selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_CONDITIONAL_CHECK) {
                    <div class="row">
                        <adaa-form-input-formula
                            [setValidator]="formValidation()!"
                            [label]="'rules_management.conditional' | translate"
                            formControlName="expression"
                            controlName="expression"
                        ></adaa-form-input-formula>
                    </div>
                }
                @if (selectedRuleType() === Constants.CONSTANT_INTEGRITY_TABLES_COMPLEX_FILE_CHECK) {
                    <div class="row">
                        <adaa-form-input-file
                            [setValidator]="formValidation()!"
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="26214400"
                            [file]="file"
                            (inputChanges)="filechange($event)"
                        ></adaa-form-input-file>
                    </div>
                }
            </div>
        </form>
    </div>
    <div class="modal=footer d-flex justify-content-center mt-3">
        <div class="my-2">
            <adaa-form-action-buttons
                [saveButtonTitle]="'common.form.button.save' | translate"
                [cancelButtonTitle]="
                    pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)
                "
                [showSaveButton]="pageMode() !== PageMode.view"
                (cancelClicked)="modal.close()"
                (saveClicked)="submit()"
            ></adaa-form-action-buttons>
        </div>
    </div>
</ng-template>
